import snapshot from './pdfOptionsCatalog.json';
export const PRINT_PAPER_SIZE_STORAGE_KEY = 'cinebudget-print-paper-size';
export const DEFAULT_PRINT_PAPER_SIZE = 'letter';

const TABLE_HEIGHT_RESERVE_PX = 66;
const fallbackPaperChoices = snapshot.groups
  .flatMap(group => group.options)
  .find(option => option.key === 'paper_size').choices;
const configurations = (choices = fallbackPaperChoices) =>
  Object.fromEntries(
    choices.map(choice => [
      choice.value,
      {
        key: choice.value,
        label: choice.label,
        pageStyleSize: `${choice.width_points}pt ${choice.height_points}pt`,
        widthCss: `${choice.width_points}pt`,
        heightCss: `${choice.height_points}pt`,
        pageHeightPixels: (choice.height_points * 96) / 72,
      },
    ])
  );
export const PRINT_PAPER_SIZES = configurations();
export const PRINT_PAPER_SIZE_OPTIONS = Object.values(PRINT_PAPER_SIZES);
export const normalizePrintPaperSize = (paperSize, choices) =>
  configurations(choices)[paperSize] ? paperSize : DEFAULT_PRINT_PAPER_SIZE;
export const getPrintPaperSize = (paperSize, choices) => {
  const config =
    configurations(choices)[normalizePrintPaperSize(paperSize, choices)];
  return {
    ...config,
    maxTableHeightPixels: config.pageHeightPixels - TABLE_HEIGHT_RESERVE_PX,
  };
};

const getLocaleRegion = locale => {
  const normalizedLocale = locale?.toString?.().replace('_', '-');
  const localeParts = normalizedLocale?.split('-') || [];
  return localeParts.length > 1 ? localeParts[localeParts.length - 1] : '';
};

const getDefaultPaperSizeFromLocale = () => {
  if (typeof navigator === 'undefined') return DEFAULT_PRINT_PAPER_SIZE;

  const locale = navigator.languages?.[0] || navigator.language || '';
  const region = getLocaleRegion(locale).toUpperCase();

  if (!region) return DEFAULT_PRINT_PAPER_SIZE;
  return ['US', 'CA'].includes(region) ? 'letter' : 'a4';
};

export const getInitialPrintPaperSize = choices => {
  if (typeof window === 'undefined') return DEFAULT_PRINT_PAPER_SIZE;

  const storedPaperSize = window.localStorage?.getItem(
    PRINT_PAPER_SIZE_STORAGE_KEY
  );

  if (configurations(choices)[storedPaperSize]) return storedPaperSize;
  return getDefaultPaperSizeFromLocale();
};

export const persistPrintPaperSize = (paperSize, choices) => {
  if (typeof window === 'undefined') return;

  window.localStorage?.setItem(
    PRINT_PAPER_SIZE_STORAGE_KEY,
    normalizePrintPaperSize(paperSize, choices)
  );
};

export const getPrintPaperCssVariables = (paperSize, choices) => {
  const config = getPrintPaperSize(paperSize, choices);

  return {
    '--cbp-print-page-width': config.widthCss,
    '--cbp-print-page-height': config.heightCss,
  };
};

export const getPrintPaperClassName = (paperSize, choices) =>
  `budget-data-container--paper-${getPrintPaperSize(paperSize, choices).key}`;

export const getPrintPaperPageStyle = (paperSize, choices) => {
  const config = getPrintPaperSize(paperSize, choices);

  return `@page { size: ${config.pageStyleSize}; margin: 16mm; }`;
};
